import { NAMESPACE } from 'locale'
import { incidentReportsConstants } from 'locale/incidentReports'
import { useTranslation } from 'react-i18next'
import type { IncidentCaseV2ReadPanelProps } from '../../incidentCaseV2Steps'
import { ReadItem, ReadWide } from '../readLayout'
import { immediateActionLabels } from '../readRules'

/** Step 2, read only: the actions taken, as `immediateActionLabels` orders them. */
const ImmediateActionsReadPanel = ({
  incidentReport
}: IncidentCaseV2ReadPanelProps) => {
  const { t } = useTranslation(NAMESPACE.INCIDENT_REPORTS)

  return (
    <ReadWide>
      <ReadItem
        label={t(incidentReportsConstants.CASE_V2_IMMEDIATE_ACTIONS_TAKEN)}
        value={immediateActionLabels(t, incidentReport)}
        testId="incident-case-v2-view-immediate-actions-taken"
      />
    </ReadWide>
  )
}

export default ImmediateActionsReadPanel
